<template>
  <article
    class="flex flex-col gap-1.5 rounded-md border border-lightGray30 bg-white p-2.5 text-left"
    :data-testid="`ds-attendance-kanban-card-${container.id}`"
  >
    <div class="flex items-center justify-between gap-2 text-xs text-neutral50">
      <span class="font-bold">#{{ container.id }} · {{ kindLabel }}</span>
      <span>Plantão {{ formatReferenceDay(container.referenceDate) }}</span>
    </div>
    <p class="m-0 text-sm font-bold text-textPrimary">
      {{ container.schedule?.name ?? 'Escala não informada' }}
    </p>
    <p class="m-0 text-xs text-neutral50">
      {{ container.healthUnit?.name ?? 'Unidade não informada' }} · {{ shiftNames(container) }}
    </p>
    <!-- G1-2: o reprovado se distingue no Encerrado pelo próprio StatusBadge ("Reprovado"). -->
    <div class="flex flex-wrap items-center gap-1">
      <StatusBadge :status="container.status" />
    </div>
    <DsAttendanceSlaLine :container="container" :now-ms="nowMs" />
    <button
      type="button"
      class="self-end text-xs font-medium text-primary underline"
      :data-testid="`ds-attendance-kanban-card-${container.id}-details`"
      @click="emit('details', container.id)"
    >
      Ver detalhes
    </button>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import StatusBadge from '@/components/designSystem/Badges/StatusBadge.vue'
import { CONTAINER_KIND_LABELS, ContainerKind } from '@/constants/ds-attendance.constants'
import type { DSAttendanceContainer } from '@/types/ds-attendance.types'

import { formatReferenceDay, shiftNames } from '../../utils/queue-table-columns'
import DsAttendanceSlaLine from './DsAttendanceSlaLine.vue'

/** Cartão compacto do Kanban (mockups K1/K2). Sem arrastar (Q4): muda de coluna na recarga. */
const props = defineProps<{ container: DSAttendanceContainer; nowMs: number | null }>()
const emit = defineEmits<{ details: [id: number] }>()

const kindLabel = computed(() =>
  props.container.kind === ContainerKind.ATIVIDADE
    ? CONTAINER_KIND_LABELS[ContainerKind.ATIVIDADE]
    : CONTAINER_KIND_LABELS[ContainerKind.FOLHA]
)
</script>
